<header class="modal-header header">
  {{ (isEditing ? Localization.EditContact : Localization.NewContact) | translate }}
  <a (click)="cancel()" aria-label="Close" class="close pull-right">
    <span aria-hidden="true">×</span>
  </a>
</header>
<main>
  <form>
    <chapps-email-input [control]="form.emailField"
                        [isRequired]="true"
                        [label]="Localization.Email"></chapps-email-input>
    <chapps-select-input [control]="form.languageField"
                         [isRequired]="true"
                         [items]="languages"
                         [label]="Localization.Language"></chapps-select-input>
    <chapps-text-input [control]="form.firstNameField"
                       [isRequired]="true"
                       [label]="Localization.FirstName"></chapps-text-input>
    <chapps-text-input [control]="form.lastNameField"
                       [isRequired]="true"
                       [label]="Localization.LastName"></chapps-text-input>
    <chapps-text-input [control]="form.companyField"
                       [label]="Localization.Company"></chapps-text-input>
    <chapps-date-picker-input [control]="form.dateOfBirthField"
                              [label]="Localization.BirthDate"></chapps-date-picker-input>
    <chapps-radio-input [control]="form.genderField"
                        [items]="genders"></chapps-radio-input>
    <chapps-text-input [control]="form.phoneNumberField"
                       [label]="Localization.PhoneNumber"></chapps-text-input>
    <chapps-text-input [control]="form.nationalRegistrationNrField"
                       [label]="Localization.NationalIdentificationNumber"></chapps-text-input>
  </form>
</main>

<footer class="modal-footer justify-content-end">
  <chapps-secondary-button (clicked)="save()"
                           [disabled]="!canSave"
                           [label]="isEditing ? Localization.Save : Localization.Create"
                           [loading]="saving"
                           [small]="true">
  </chapps-secondary-button>
</footer>
